import Vue from 'vue'

export const funcoes = {
    ucWords(str) {
        let strLower = str.toLowerCase()
        let re = /(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g
        return strLower.replace(re, s => s.toUpperCase());
    },
    montarEndereco(endereco) {
        let strEndereco = '';
        let separador = false;
        if ('logradouro' in endereco) {
            if (!this.isEmpty(endereco.logradouro)) {
                strEndereco += `${endereco.logradouro}`;
                separador = true;
            }
        }
        if ('numero' in endereco) {
            if (!this.isEmpty(endereco.numero)) {
                if (separador) {
                    strEndereco += ', ';
                }
                strEndereco += `${endereco.numero}`;
                separador = true;
            }
        }
        if ('bairro' in endereco) {
            if (!this.isEmpty(endereco.bairro)) {
                if (separador) {
                    strEndereco += ' - ';
                }
                strEndereco += `${endereco.bairro}`;
                separador = true;
            }
        }
        if ('cidade' in endereco) {
            if (!this.isEmpty(endereco.cidade)) {
                if (separador) {
                    strEndereco += ', ';
                }
                strEndereco += `${endereco.cidade}`;
                separador = true;
            }
        }
        if ('estado' in endereco) {
            if (!this.isEmpty(endereco.estado)) {
                if (separador) {
                    strEndereco += ' - ';
                }
                strEndereco += `${endereco.estado}`;
            }
        }
        if ('referencia' in endereco) {
            if (!this.isEmpty(endereco.referencia)) {
                strEndereco += `<br>`;
                strEndereco += `${endereco.referencia} `;
            }
        }
        return this.ucWords(strEndereco);
    },
    isEmpty(value) {
        return (
            typeof value === 'undefined' ||
            value === undefined ||
            value == '' ||
            value == null ||
            (typeof value === 'object' && Object.keys(value).length == 0)
        );
    },
    removeSegundos(dataPt) {
        if (!this.isEmpty(dataPt)) {
            return Vue.prototype.$moment(dataPt, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm");
        }
        return '';
    },
    notifyDesktop(options) {        
        if (!("Notification" in window)) {
            console.log("Navegador não suporta o serviço de notificação");
            return;
        }

        Notification.requestPermission(function(result) {
            if (result === 'granted') {
                navigator.serviceWorker.ready.then(function(registration) {
                    registration.showNotification(options.title, options);
                });
            }
        });
    },
    mensagemRetorno(error, response, mensagemPadrao) {
        let message = mensagemPadrao;
        if (error === true) {
            if (
                Object.prototype.hasOwnProperty.call(response, 'response') && 
                Object.prototype.hasOwnProperty.call(response.response, 'status') && response.response.status < 500 &&
                Object.prototype.hasOwnProperty.call(response.response, 'data') && Object.prototype.hasOwnProperty.call(response.response.data, 'mensagem')
            ) {
                message = response.response.data.mensagem;
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response, 'data') && Object.prototype.hasOwnProperty.call(response.data, 'mensagem')) {
                message = response.data.mensagem;
            }
        }

        return { error, message };
    },
    substituiVazio(str, substituirPor) {
        if (substituirPor == undefined) {
            substituirPor = '';
        }

        if (this.isEmpty(str)) {
            return substituirPor;
        }

        return str;
    },
    /**
     * 
     * @param {string} tempo No formato hh:ii:ss
     * @returns int
     */
    tempoEmMinutos (tempo) {
        if (this.isEmpty(tempo)) {
            return 0;
        }

        const array = tempo.split(':');
        const minutos = (+array[0]) * 60 + (+array[1]);
        return minutos;
    },

    uniqueID() {
        return Math.floor(Math.random() * Math.floor(Math.random() * Date.now()))
    }
}